import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import Quotes from './pages/Quotes';
import CreateQuote from './pages/CreateQuote';

import { AuthProvider } from './hooks/useAuth';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotte pubbliche */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Rotte protette */}
          <Route
            path="/quotes"
            element={
              <PrivateRoute>
                <MainLayout><Quotes /></MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/create-quote"
            element={
              <PrivateRoute>
                <MainLayout><CreateQuote /></MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <MainLayout><Profile /></MainLayout>
              </PrivateRoute>
            }
          />

          {/* Catch all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
